(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabs-collection-component')) {
    class TabsCollectionComponent extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

        if (!this.tabs.length) return;

        this.activate(0);

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
        });

        this.initInfiniteScroll();
      }

      initInfiniteScroll() {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.isLoading) {
              this.loadNextBatch(entry.target);
            }
          });
        }, { threshold: 0.1 });

        this.querySelectorAll('.infinite-loader').forEach(loader => {
          this.observer.observe(loader);
        });
      }

      loadNextBatch(loader) {
        const panel = loader.closest('.tabs-collection__panel');
        if (!panel || panel.hidden) return;

        const currentBatch = parseInt(loader.dataset.currentBatch);
        const maxBatch = parseInt(loader.dataset.maxBatch);
        const nextBatch = currentBatch + 1;

        if (nextBatch > maxBatch) {
          loader.remove();
          return;
        }

        this.isLoading = true;
        loader.style.visibility = 'visible';

        // Simulated delay for "loader for a second"
        setTimeout(() => {
          const itemsToShow = panel.querySelectorAll(`.resource-list__item[data-batch="${nextBatch}"]`);
          itemsToShow.forEach(item => {
            item.hidden = false;
            item.style.display = 'block';
          });

          loader.dataset.currentBatch = nextBatch;
          this.isLoading = false;

          if (nextBatch >= maxBatch) {
            loader.remove();
          }
          
          window.dispatchEvent(new Event('resize'));
        }, 1000);
      }

      activate(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active);
          tab.classList.toggle('is-active', active);
        });

        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.hidden = !active;
          panel.setAttribute('aria-hidden', !active);
          if (active) {
            panel.removeAttribute('inert');
            window.dispatchEvent(new Event('resize'));
          } else {
            panel.setAttribute('inert', '');
          }
        });
      }
    }

    customElements.define('tabs-collection-component', TabsCollectionComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
